/* Separate from the original [data-zoom] image handler. */
(()=>{
if(window.__vhLocalizedGalleryZoom)return;window.__vhLocalizedGalleryZoom=true;
let opener,dialog,content,image,priorLabel;
document.addEventListener('click',event=>{
const path=event.composedPath?.()||[];
if(path.some(node=>node?.matches?.('[data-thumb]')))return;
const button=event.target.closest('[data-localized-zoom]');
if(!button||!path.includes(button))return;
dialog=document.querySelector('[data-zoom-dialog]');
const artwork=button.querySelector('.vh-l10n-art');
if(!dialog||!artwork)return;
opener=button;image=dialog.querySelector('[data-zoom-image]');priorLabel=dialog.getAttribute('aria-label');
content=dialog.querySelector('[data-localized-zoom-content]');
if(!content){content=document.createElement('div');content.dataset.localizedZoomContent='';dialog.append(content);}
const clone=artwork.cloneNode(true);clone.querySelectorAll('[id]').forEach(node=>node.removeAttribute('id'));
content.replaceChildren(clone);content.hidden=false;
if(image)image.hidden=true;
dialog.classList.add('vh-l10n-gallery','vh-l10n-zoom');dialog.setAttribute('aria-label',artwork.getAttribute('aria-label')||priorLabel||'');
if(!dialog.open)dialog.showModal();
dialog.addEventListener('close',()=>{
content.replaceChildren();content.hidden=true;if(image)image.hidden=false;
dialog.classList.remove('vh-l10n-gallery','vh-l10n-zoom');
if(priorLabel!==null)dialog.setAttribute('aria-label',priorLabel);else dialog.removeAttribute('aria-label');
opener?.focus({preventScroll:true});
},{once:true});
});
})();
